import type { FC } from 'react';

import { SubHeaderTitle } from '@app/components/Skeleton/Skeleton';
import useShopProduct from '@app/pages/Pricing/hook/useShopProduct';

const Title: FC<{ sku: string | undefined; title: string }> = ({
  sku,
  title,
}) => {
  const { magentoProduct } = useShopProduct(sku);
  const detailPageUrl = magentoProduct?.detailPage || '';

  return (
    <SubHeaderTitle data-testid="pricing-header-title">
      <a href={detailPageUrl}>{title}</a>
    </SubHeaderTitle>
  );
};

export default Title;
